import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { keyframes } from '@emotion/react';
import { Box } from '../Box';
import { useThemeProps } from '../system';
var rotate = keyframes({
  '100%': {
    transform: 'rotate(360deg)'
  }
});
var rotateCentered = keyframes({
  '100%': {
    transform: 'translate(-50%, -50%) rotate(360deg)'
  }
});
export function Spinner(_ref) {
  var center = _ref.center,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      thickness = _ref.thickness,
      props = _objectWithoutPropertiesLoose(_ref, ["center", "size", "thickness"]);

  var _useThemeProps = useThemeProps('spinner', props),
      color = _useThemeProps.color,
      sizes = _useThemeProps.sizes,
      sizeThickness = _useThemeProps.thickness,
      trackColor = _useThemeProps.trackColor,
      restProps = _objectWithoutPropertiesLoose(_useThemeProps, ["color", "sizes", "thickness", "trackColor"]);

  var boxProps = {
    inline: true,
    alignSelf: 'center',
    verticalAlign: 'middle',
    radius: 'circle',
    borderColor: trackColor,
    borderTopColor: color
  };
  var sizeValue = sizes[size] || size;
  var thicknessValue = thickness || sizeThickness[size];
  var boxSizeStyles = {
    borderWidth: thicknessValue,
    height: sizeValue,
    width: sizeValue
  };

  if (process.env.NODE_ENV !== 'production') {
    var width = typeof sizeValue === 'number' ? sizeValue * 8 : sizeValue.includes('px') ? parseInt(sizeValue) : null;
    var spinnerRadius = width && width / 2;
    if (spinnerRadius && thicknessValue > spinnerRadius) console.warn("The thickness value (" + thicknessValue + "px) of this spinner is larger than the radius (" + spinnerRadius + "px), this will distort the rendered size.");
  }

  if (center) {
    boxProps.position = 'absolute';
    boxProps.left = '50%';
    boxProps.top = '50%';
    boxProps.transform = 'translate(-50%, -50%) rotate(0deg)';
    boxProps.animation = rotateCentered + " 500ms infinite linear";
  } else {
    boxProps.transform = 'rotate(0deg)';
    boxProps.animation = rotate + " 500ms infinite linear";
  }

  return /*#__PURE__*/React.createElement(Box, _extends({}, boxProps, boxSizeStyles, restProps));
}